<template>
  <!-- 添加或编辑系列 -->
  <el-dialog :visible.sync="addOrEditSeriesDialog" width="500px" :title="title" @close="onClose">
    <el-form
      :model="queryParams"
      ref="queryParamsRefs"
      :rules="queryParamsRules"
      label-width="110px"
    >
      <el-row>
        <el-col :span="22">
          <el-form-item prop="brandId" label="品牌名称：">
            <el-select v-model.trim="queryParams.brandId" filterable placeholder="请选择">
              <el-option
                v-for="item in brandList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item prop="seriesName" label="系列名称：">
            <el-input v-model.trim="queryParams.seriesName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <!-- <el-form-item label="系列组：">
        <el-select v-model="queryParams.serialGroupId" placeholder="请选择">
          <el-option
            v-for="item in serialGroupList"
            :key="item.id"
            :label="item.bgName"
            :value="item.id">
          </el-option>
        </el-select>
          </el-form-item>-->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item prop="seriesNickname" label="系列别称：">
            <el-input v-model.trim="queryParams.seriesNickname"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item prop="mark" label="描述：">
            <el-input v-model.trim="queryParams.mark" placeholder="请输入对系列的描述" type="textarea"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">确 定</el-button>
      <el-button @click="onClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
// queryAllSeriesGroup
import {
  brandSeriesAdd,
  brandSeriesUpdateById
} from '@/api/product/productManage'
import { addOrEditSeriesRules } from '../utils/formRules'
export default {
  data () {
    return {
      addOrEditSeriesDialog: false,
      // 添加系列
      queryParams: {
        brandId: undefined,
        createDate: '',
        createIp: 0,
        createUser: '',
        flag: true,
        id: 0,
        isStopCoefficient: 0,
        lastDate: '',
        lastIp: 0,
        lastUser: '',
        mark: '',
        serial: 0,
        seriesCoefficient: 0,
        seriesName: '',
        seriesNickname: ''
      },
      title: '',
      type: 0,
      serialGroupList: [], // 系列组
      brandList: [], // 品牌名称
      queryParamsRules: {}
    }
  },
  methods: {
    // 添加,编辑系列初始化type=2编辑系列type=1添加系列
    onInitialize (type, row) {
      this.queryParams = {

        createDate: '',
        createIp: 0,
        createUser: '',
        flag: true,
        id: 0,
        isStopCoefficient: 0,
        lastDate: '',
        lastIp: 0,
        lastUser: '',
        mark: '',
        serial: 0,
        seriesCoefficient: 0,
        seriesName: '',
        seriesNickname: ''
      }
      this.queryParamsRules = addOrEditSeriesRules
      this.type = type
      if (this.type === 2) {
        this.title = '编辑系列'
        this.queryParams = JSON.parse(JSON.stringify(row))
      } else {
        this.title = '添加系列'
      }
      this.addOrEditSeriesDialog = true
      this.getBrandForSelect()
    },

    // // 获取所有系列组
    // getQueryAllSeriesGroup () {
    //   queryAllSeriesGroup().then(res => {
    //     if (res.data.code === 200) {
    //       this.serialGroupList = res.data.obj
    //     }
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // },
    // 获取所有品牌名称
    async getBrandForSelect () {
      this.brandList = await this.$queryAllBrandForSelect()
    },
    handleClose () {
      this.queryParamsRules = {}
      this.addOrEditSeriesDialog = false
    },
    // 确定
    onSubmit () {
      this.$refs.queryParamsRefs.validate((valid) => {
        if (valid) {
          // 校验通过
          if (this.type === 1) {
            brandSeriesAdd(this.queryParams)
              .then((res) => {
                // 添加系列
                if (res.data.code === 200) {
                  this.$message.success('添加成功!')
                  this.$emit('onRefresh')
                  this.addOrEditSeriesDialog = false
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch((err) => {
                console.log(err)
              })
          } else {
            brandSeriesUpdateById(this.queryParams)
              .then((res) => {
                // 编辑系列
                if (res.data.code === 200) {
                  this.$message.success('修改成功!')
                  this.$emit('onRefresh')
                  this.addOrEditSeriesDialog = false
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch((err) => {
                console.log(err)
              })
          }
        } else {
          this.$message.error('校验未通过')
          return false
        }
      })
    },
    // 取消关闭弹窗
    onClose () {
      this.$nextTick(() => {
        this.$refs.queryParamsRefs.resetFields() // 去掉校验
      })
      this.addOrEditSeriesDialog = false
    }

  }
}
</script>

<style>
</style>
